import { render, staticRenderFns } from "./VerificationDropdownBlock.vue?vue&type=template&id=145edc75&scoped=true"
import script from "./VerificationDropdownBlock.vue?vue&type=script&lang=js"
export * from "./VerificationDropdownBlock.vue?vue&type=script&lang=js"
import style0 from "./VerificationDropdownBlock.vue?vue&type=style&index=0&id=145edc75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145edc75",
  null
  
)

export default component.exports